// Grade teams, in school order. `id` doubles as the anchor on /our-classes and
// on each grade's newest issue of /newsletters, so links like /newsletters#grade-2 work.
//
// `color` backs white text (newsletter badges and pills), so it must clear
// 4.5:1 against white; `lightColor` sits behind icons drawn in `color` (3:1).

const grades = [
  {
    id: 'pre-k',
    short: 'PK',
    label: 'Pre-K',
    fullLabel: 'Pre-Kindergarten',
    color: '#9333EA',
    lightColor: '#F3E8FF',
    photo: { src: '/assets/images/grade-teams/pre-k.jpg', width: 736, height: 770 },
  },
  {
    id: 'kindergarten',
    short: 'K',
    label: 'Kindergarten',
    fullLabel: 'Kindergarten',
    color: '#1B365D',
    lightColor: '#EFF6FF',
    photo: { src: '/assets/images/grade-teams/kindergarten.jpg', width: 1200, height: 1049 },
  },
  {
    id: 'grade-1',
    short: '1',
    label: '1st Grade',
    fullLabel: '1st Grade',
    color: '#B91C1C',
    lightColor: '#FEF2F2',
    photo: { src: '/assets/images/grade-teams/grade-1.jpg', width: 1200, height: 855 },
  },
  {
    id: 'grade-2',
    short: '2',
    label: '2nd Grade',
    fullLabel: '2nd Grade',
    color: '#0F766E',
    lightColor: '#F0FDFA',
    photo: { src: '/assets/images/grade-teams/grade-2.jpg', width: 1200, height: 874 },
  },
  {
    id: 'grade-3',
    short: '3',
    label: '3rd Grade',
    fullLabel: '3rd Grade',
    // Deep gold: the lighter school gold #C59132 only reaches 2.8:1 on white.
    color: '#7D5800',
    lightColor: '#FFFBEB',
    photo: { src: '/assets/images/grade-teams/grade-3.jpg', width: 1200, height: 640 },
  },
  {
    id: 'grade-4',
    short: '4',
    label: '4th Grade',
    fullLabel: '4th Grade',
    color: '#1D4ED8',
    lightColor: '#EFF6FF',
    photo: { src: '/assets/images/grade-teams/grade-4.jpg', width: 989, height: 674 },
  },
  {
    id: 'grade-5',
    short: '5',
    label: '5th Grade',
    fullLabel: '5th Grade',
    color: '#BE185D',
    lightColor: '#FDF2F8',
    photo: { src: '/assets/images/grade-teams/grade-5.jpg', width: 1200, height: 834 },
  },
];

export const gradeById = Object.fromEntries(grades.map((g) => [g.id, g]));

export default grades;
